import {
  ReceiptsStatisticsState,
  REQUEST_RECEIPTSTATISTICS,
  REQUEST_RECEIPTSTATISTICS_DONE
} from "./types";

const initialState: ReceiptsStatisticsState = {
  isLoading: true,
  receiptStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_RECEIPTSTATISTICS:
      return {
        isLoading: true,
        receiptStatistics: action.payload
      };
    case REQUEST_RECEIPTSTATISTICS_DONE:
      return {
        isLoading: false,
        receiptStatistics: action.payload
      };
    default:
      return state;
  }
}
